import {Captions, Controls, Gesture, Time} from '@vidstack/react'

import captionStyles from './parts/captions.module.scss'
import styles from './parts/video-layout.module.scss'
import * as Buttons from './parts/Buttons'
import * as Sliders from './parts/Sliders'

import type {PlayButtonProps} from '@vidstack/react'

export interface VideoLayoutProps {
  thumbnails?: string
  playButtonProps?: PlayButtonProps
}

export const VideoLayout = ({thumbnails, playButtonProps}: VideoLayoutProps) => (
  <>
    <Gestures />
    <Captions
      className={`${captionStyles.captions} absolute inset-0 bottom-2 z-10 select-none break-words opacity-0 transition-[opacity,bottom] duration-300 media-captions:opacity-100 media-controls:bottom-[85px] media-preview:opacity-0`}
    />
    <Controls.Root
      className={`${styles.controls} absolute inset-0 z-10 flex size-full flex-col bg-gradient-to-t from-black/10 to-transparent opacity-0 transition-opacity media-controls:opacity-100`}
    >
      <div className={'flex-1'} />
      <Controls.Group className={'-mt-0.5 flex w-full items-center px-2 pb-2'}>
        <Buttons.Play
          tooltipPlacement={'top start'}
          {...playButtonProps}
        />
        <Sliders.Time thumbnails={thumbnails} />
        <Time
          className={'time text-white'}
          type={'current'}
        />
        <Buttons.Mute tooltipPlacement={'top'} />
        <Sliders.Volume />
        <div className={'flex-1'} />
        <Buttons.Fullscreen tooltipPlacement={'top end'} />
      </Controls.Group>
    </Controls.Root>
  </>
)

const Gestures = () => (
  <>
    <Gesture
      className={'absolute inset-0 z-0 block size-full'}
      event={'click'}
      action={'toggle:paused'}
    />
    <Gesture
      className={'absolute inset-0 z-0 block size-full'}
      event={'dblclick'}
      action={'toggle:fullscreen'}
    />
    <Gesture
      className={'absolute left-0 top-0 z-10 block h-full w-1/5'}
      event={'dblclick'}
      action={'seek:-10'}
    />
    <Gesture
      className={'absolute right-0 top-0 z-10 block h-full w-1/5'}
      event={'dblclick'}
      action={'seek:10'}
    />
  </>
)
